import { useMutation } from "@tanstack/react-query";

import { callApi } from "../utils/ApiCallPostOnly";

export const useStaffUpdate = () => {
  return useMutation({
    mutationFn: (data) =>
      callApi({
        path: "updateStaff",
        command: "",
        data: JSON.stringify(data),
      }),
  });
};
